import { render, staticRenderFns } from "./theQuerV2.vue?vue&type=template&id=a37c3316&scoped=true&"
import script from "./theQuerV2.vue?vue&type=script&lang=js&"
export * from "./theQuerV2.vue?vue&type=script&lang=js&"
import style0 from "./theQuerV2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./theQuerV2.vue?vue&type=style&index=1&id=a37c3316&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37c3316",
  null
  
)

export default component.exports